
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 13c2.9-1.5 4.7-.8 6-2 0 0 .5 5.4-2 7-1.2.7-2.6 1.1-4 1-.4.2-.8.6-1 1-.1.3-1.1.3-1 0 1-2.9 3.3-4.6 5-6 0 0-4 1-5 4 0 0-.9-3.5 2-5zm-6 0c-2.9-1.5-4.7-.8-6-2 0 0-.5 5.4 2 7 1.2.7 2.6 1.1 4 1 .4.2.8.6 1 1 .1.3 1.1.3 1 0-1-2.9-3.3-4.6-5-6 0 0 4 1 5 4 0 0 .9-3.5-2-5zm5-5c-1.4-3-2.7-3.2-3-5 0 0-3 4.1-2 7 .6 1.6 2.2 2.4 3 3 .4-1.6.4-3.4 0-5 1.3 1.3 1.7 3.3 1 5 1.4-1.2 1.9-3.3 1-5z"}})])
          )
        }
      }
    